import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import './DataPointsMetrics.scss';
import { withTranslation } from "react-i18next";
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import { OverlayTrigger, Table, Tooltip } from "react-bootstrap";
import { useParams } from 'react-router';
import SubStdService from '../../../core/service/SubStdService';
import { BiInfoCircle, BiPencil } from 'react-icons/bi';
import Utils from '../../../core/utilities/Utils';
import { BsXSquare } from 'react-icons/bs';
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import moment from 'moment';
import { RegulationContext } from '../../../App';

const DataPointsMetrics = ({ 
  t, 
  metric_id, 
  date, 
  std_id, 
  handleclose, 
  handlesave,
  stdName,
  categoryName,
  topicName,
  metricName,
  equationData,
  showHeader,
  uomList
}) => {
  // const { metric_id } = useParams();
  // const { date } = useParams();
  // const { std_id } = useParams();
  const [maintabledata, setMainTableData] = useState([]);
  const [iseditable, setIsEditable] = useState(false);
  const [senddatapoints, setSendDataPoints] = useState([]);
  const { glbRegulation, setGlbRegulation } = useContext(RegulationContext);
  const navigate = useNavigate();
  const [inputValue, setInputValue] = useState('');

  useEffect(() => {
    if (metric_id !== undefined && metric_id != null && metric_id !== ''
      && std_id !== undefined && std_id != null && std_id !== ''
      && date !== undefined && date != null && date !== '') {
      getBranchBasedData();
    }
  }, [std_id, date]);

  const getBranchBasedData = () => {
    SubStdService.getBranchBasedData(std_id, metric_id, date)
      .then((response) => {
        setMainTableData([...response.data.dataPoints])
      })
      .catch((error) => {
        console.log("err", error);
      });
  };

  const updateFieldChanged = (metricbranchDat, dataPointId) => (e) => {
    let data = [...senddatapoints];
    const index = data.findIndex((x) => ((x.branchId == metricbranchDat.branchId) && (x.dataPointId == dataPointId)));
    if (index >= 0) {
      data[index].value = e.target.value;
      setSendDataPoints(data);
    } else {
      let dat = {
        id: metricbranchDat.id,
        value: e.target.value,
        dataPointId: dataPointId,
        branchId: metricbranchDat.branchId,
        uom: metricbranchDat.uomBeforeConversion ? metricbranchDat?.uomBeforeConversion : metricbranchDat?.uom
      };
      data.push(dat);
      setSendDataPoints(data);
    }
  };

  const onUOMChange = (metricbranchDat, dataPointId) => (e) => {
    let data = [...senddatapoints];
    const index = data.findIndex((x) => ((x.branchId == metricbranchDat.branchId) && (x.dataPointId == dataPointId)));
    if (index >= 0) {
      data[index].uom = e.target.value;
      setSendDataPoints(data);
    } else {
      let dat = {
        id: metricbranchDat.id,
        value: metricbranchDat?.valueBeforeConversion ? metricbranchDat?.valueBeforeConversion : metricbranchDat?.value,
        dataPointId: dataPointId,
        branchId: metricbranchDat.branchId,
        uom: e.target.value
      };
      data.push(dat);
      setSendDataPoints(data);
    }
  };

  const submitBrDataPoint = async (e) => {
    if (senddatapoints.length === 0) {
      setIsEditable(false);
      return;
    }
    let isValid = true;
    for (let i = 0; i < senddatapoints.length; i++) {
      const dp = senddatapoints[i];
      if (dp.value && !dp.uom) {
        isValid = false;
        break;
      }      
    }
    if (!isValid) {
      toast.error(t("UnitNotSelected.label"), {
        position: toast.POSITION.TOP_RIGHT,
      });
      return;
    }
    var objBody = {
      dataPoints: senddatapoints,
    };
    // console.log('sddd',objBody);
    SubStdService.saveBranchDataPoint(std_id, date, objBody)
      .then((response) => {
        if (response.status === 200) {
          toast.success("Success", {
            position: toast.POSITION.TOP_RIGHT,
          });
          setIsEditable(false);
          setSendDataPoints([]);
          getBranchBasedData();
        }
      })
      .catch((error) => { });
  };

  const calculateData = () => {
    SubStdService.calculateEquation(metric_id, date)
      .then((response) => {
        if (response.data.data != null) {
          toast.success(response.data.message, {
            position: toast.POSITION.TOP_RIGHT,
          });
          handlesave();
        } else {

          toast.error(response.data.message, {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      })
      .catch((error) => {
        console.log('erroor', error)
        // toast.success(error.message, {
        //   position: toast.POSITION.TOP_RIGHT,
        // });
      });
  }
  const handleBackBtn = () => {
    handleclose();
  }
  // const handleKeyPress = (event) => {
  //   //Allow only numbers and decimal point
  //   if (!(event.key === "Backspace" || event.key === "Delete" || /^\d*\.?\d*$/.test(inputValue + event.key))) {
  //     event.preventDefault();
  //   }

  // };
  const handleKeyPress = (event) => {
    // Allow only numbers and at most one decimal point (safe regex)
    const safeNumberPattern = /^(?:\d+|\d*\.\d+)$/;
  
    if (
      !(
        event.key === "Backspace" ||
        event.key === "Delete" ||
        safeNumberPattern.test(inputValue + event.key)
      )
    ) {
      event.preventDefault();
    }
  };
  

  const renderTooltipCustom = (data) => {
    var activityData = data.activity;
    var strData = <Tooltip className="mytooltip">
      <div><b>Source</b> : {activityData.source}</div>
      <div><b>Last Modified by</b> : {activityData.lastModifiedBy}</div>
      <div><b>Date</b> : {moment(activityData.lastModifiedDate).format("MMM Do YYYY, h:mm a")}</div>
    </Tooltip>
    return strData;
  }

  return (

    <div className="DataPointsMetrics 1">
      {/* <div className='Breadcrumb_box py-2'>
        <Breadcrumb>
          <Breadcrumb.Item href="#">Monitor</Breadcrumb.Item>
          <Breadcrumb.Item href="#">Standards </Breadcrumb.Item>
          <Breadcrumb.Item href="#">GRI </Breadcrumb.Item>
          <Breadcrumb.Item href="#">Environmental </Breadcrumb.Item>
          <Breadcrumb.Item href="#">Report </Breadcrumb.Item>
          <Breadcrumb.Item active>GRI 302: Energy 2016</Breadcrumb.Item>
        </Breadcrumb>
      </div> */}
      {/* <div className="List_header">
        <h5 className="h5">{t("Standards.label")}</h5>

      </div> */}
      <div className='Sub_headerBox mb-2 2'>
        <ul>
          {
            showHeader &&
            <>
              <li>Standard : <b>{glbRegulation.name}</b></li>
              <li>Category : <b>{categoryName}</b></li>
              {/* <li>Section : <b>Reporting on GHG emissions</b></li> */}
              <li>Topic : <b>{topicName}</b></li>
              <li>Metric : <b>{metricName}</b></li>
            </>
          }
          <li>Equation : <b>{equationData}</b>
            <span>
              <button type="button" onClick={() => { calculateData(); }}
                className="btn btn-primary ms-2"
              >
                {t("Calculate.label")}
              </button></span>
          </li>
          {/* <li>Calculate result : <b>{equationData}</b> </li> */}
        </ul>
      </div>
      <div className="List_table-card01 ">
        {maintabledata.length > 0 && <Table responsive className='m-0 Datapoint_table' bordered>
          <thead>
            <tr>
              <th className="">Datapoint</th>
              <th className="">Unit</th>
              {/* <th className="">Code</th> */}
              <th className="">Combined</th>
              <>{maintabledata.length > 0 && maintabledata[0].branches.map((item, index) => (
                <><th>{item.name}
                  {
                    <OverlayTrigger
                      placement="top"
                      overlay={Utils.renderTooltip(iseditable ? t("CancelEdit.label") : t("Edit.label"))}>
                      {
                        iseditable
                        ?
                        <>
                          <BsXSquare
                            className="cursor ms-1"
                            onClick={() => setIsEditable(!iseditable)}></BsXSquare>{" "}
                        </>
                        : 
                        <BiPencil
                          className="cursor ms-1"
                          onClick={() => setIsEditable(!iseditable)}/>
                      }
                    </OverlayTrigger>
                  }
                </th>
                </>
              ))}</>
            </tr>
          </thead>
          <tbody>
            {maintabledata.length > 0 && maintabledata.map((item, index) => (
              <tr>
                <td>{item.name} ({item.dataPointCode})</td>
                <td>{item.unit}</td>
                <td>{item.combined}</td>
                <>
                  {item.branches.length > 0 && item.branches.map((britem, brindex) => (
                    <td>
                      <>
                        {iseditable ? (
                          <div className='w-100 d-flex'>
                            <div className='w-60'>
                              <input
                                className="form-control branch-col"
                                id={`branchValueField-${index}-${brindex}`}
                                defaultValue={britem?.valueBeforeConversion ? britem?.valueBeforeConversion : britem?.value}
                                name="value"
                                onChange={updateFieldChanged(britem, item.id)}
                                onKeyDown={handleKeyPress}
                              />
                            </div>
                            <select className='form-select w-40'
                              id={`branchUOMField-${index}-${brindex}`}
                              defaultValue={britem.uomBeforeConversion ? britem?.uomBeforeConversion : britem?.uom}
                              onChange={onUOMChange(britem, item.id)}>
                              {
                                <>
                                <option key={null} value={null}>{t("Select.label")}</option>
                                {
                                  uomList?.map(u => {
                                  return <option key={u.id} value={u.inputUnit}>{u.inputUnit}</option>
                                  })
                                }
                                </>
                              }
                            </select>
                          </div>
                        ) : (
                          <>
                            <div className='datavalue_info_tool'>
                              {
                                britem.valueBeforeConversion && britem.uomBeforeConversion 
                                ? 
                                <>
                                  <span>{`${britem.valueBeforeConversion} ${britem.uomBeforeConversion }`}</span>                                  
                                  <span className='text-muted mx-1'>{`(${britem.value} ${item.unit})`}</span>
                                </>
                                : britem.value
                              }
                              {
                                britem.value && britem.activity  
                                 ? <OverlayTrigger
                                  placement="top"
                                  overlay={renderTooltipCustom(britem)}>
                                    <span className="Info_dataView"><BiInfoCircle /></span>
                                </OverlayTrigger>
                                : ''
                              }
                            </div>
                          </>
                        )}
                      </>
                    </td>
                  ))}
                </>
                {/* <td>15,690,441</td>
                <td><b className='text-primary'>15,690,441</b></td>
                <td><b className='text-primary'>15,690,441</b></td>
                <td><b className='text-primary'>15,690,441</b></td> */}
              </tr>

            ))}

          </tbody>
        </Table>}
        {iseditable && (
          <div className="p-2 text-center">

            <button type="button" className="btn btn-secondary me-2 px-4 sbmBtn" onClick={handleBackBtn}>
              {t("Close.label")}
            </button>
            <button
              type="button"
              onClick={() => {
                submitBrDataPoint();
              }}
              className="btn btn-primary  px-4 sbmBtn"
            >
              {t("Save.label")}
            </button>
          </div>
        )}

      </div>
      {/* {!iseditable && (
        <div className="p-2 text-center">
          <button type="button" className="btn btn-primary ms-2 px-4 sbmBtn" onClick={handleBackBtn}>
            {t("Close.label")}
          </button>
        </div>
      )} */}
    </div>
  );
}

DataPointsMetrics.propTypes = {};

DataPointsMetrics.defaultProps = {};

export default withTranslation()(DataPointsMetrics);
